<div>
  <button id="quoteHistoryBtn" mat-flat-button color="accent" type="button" (click)="getQuoteHistoryDialog()">
    <img src="/assets/icons/icon-money.svg" class="prefix" alt="quote history"/>
    <span>History</span>
  </button>
</div> 
